import { http, cInfrastructures } from "@di";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
import understandUseCases from "../../understandingCommonDI/understandUseCases";
import JwtTokenNestRepository from "@adapters/repositories/Common/JwtTokenNest";
import JwtTokenNestUseCase from "@domains/useCases/Common/JwtTokenNestUseCase";
import ExtPlatDataRetrieveUseCase from "@domains/useCases/Common/ExtPlatDataRetrieveUseCase";
import ExtPlatDataRetrieveRepo from "@adapters/repositories/Common/ExtPlatDataRetrieveRepo";
import RetrieveExtPlatAccDataUseCase from "@domains/useCases/Common/RetrieveExtPlatAccDataUseCase";
const understandUseCase = understandUseCases();
const cRepositorires = repositories(http, cInfrastructures);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions, understandUseCase);
export const jwtTokenFetchUseCase = new JwtTokenNestUseCase(new JwtTokenNestRepository(http));
export const extPlatDataRetrieveUseCase = new ExtPlatDataRetrieveUseCase(new ExtPlatDataRetrieveRepo(http));
export const retrieveExtPlatAccDataUseCase = new RetrieveExtPlatAccDataUseCase(new ExtPlatDataRetrieveRepo(http));
export default {
    holdingReport: cPresenters.holdingReport,
};
